import axios from "axios";
import projectConfig from "@projectConfig";
import { appVersionInterceptor } from "../util/interceptors/appVersionInterceptor";
import { credentialsInterceptor } from "../util/interceptors/credentialsInterceptor";
import { safariTokenInterceptor } from "../util/interceptors/safariTokenInterceptor";

export const pocService = projectConfig.api.pocService;

export const pocClient = axios.create({
   baseURL: pocService,
   headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
   },
});

// Apply POC-relevant interceptors only (no legacy-specific or store-dependent ones)
pocClient.interceptors.request.use(credentialsInterceptor.request);
pocClient.interceptors.request.use(safariTokenInterceptor.request);
pocClient.interceptors.response.use(appVersionInterceptor.response);

pocClient.interceptors.request.use((config) => {
   const token = localStorage.getItem("pocJWT");
   if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = token;
   } else if (config.headers) {
      delete config.headers.Authorization;
   }
   return config;
});
